import { render, staticRenderFns } from "./listaRespProyectos.vue?vue&type=template&id=3979b4f6"
import script from "./listaRespProyectos.vue?vue&type=script&lang=js"
export * from "./listaRespProyectos.vue?vue&type=script&lang=js"
import style0 from "./listaRespProyectos.vue?vue&type=style&index=0&id=3979b4f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports